export default __webpack_public_path__ + "static/media/partyOver.a76fc6a6.jpg";